<template>
  <div class="video-container" style="height: 100vh; display: flex; flex-direction: column;" @contextmenu.prevent>
    <!-- 头部区域 -->
    <div class="header" style="width: 100%; background: rgba(0, 0, 0, 0.1); display: flex; z-index: 10;">
      <div style="width: 5%; text-align: center; align-items: center; cursor: pointer;">
        <i class="el-icon-back" style="font-size: 3rem;" @click="toHome"></i>
      </div>
      <div class="title-bar" style="display: flex; align-items: center;">
        <img src="/static/img/Frame4.png" style="width: 3rem; height: 3rem;">
        <span style="margin-left: 0.6rem; font-weight: bold;">视频讲解</span>
      </div>
    </div>

    <!-- 新增一个父容器用于左右分列 -->
    <div style="display: flex; flex: 1; overflow: hidden;">
      <!-- 视频播放区域 - 固定在顶部 -->
      <div class="video-wrapper"
        style="flex: 0.7; position: sticky; top: 0; height: 100vh; overflow: auto; padding: 1rem;">
        <div style="width: 100%;">
          <!-- 视频区域 -->
          <div>
            <!-- 添加controlsList="nodownload"属性禁用下载按钮 -->
            <video object-fit="contain" :loop="false" poster="/static/img/banner.png" id="myVideo" :src="videoSrc"
              controls controlsList="nodownload" @contextmenu.prevent @error="videoError" @play="videoPlay" @ended="nextVideo" :class="{ 'video-playing': playOrStop }"
              style="width: 100%; max-width: 100%; box-shadow: 0 4px 15px rgba(0,0,0,0.15);">
            </video>
          </div>
          <!-- 控制按钮 -->
          <div class="control-buttons" style="display: flex; justify-content: center; margin: 15px 0;">
            <button @click="upVideo" class="control-btn">上一题</button>
            <button @click="playVideo" class="control-btn">播放</button>
            <button @click="pauseVideo" class="control-btn">暂停</button>
            <button @click="nextVideo" class="control-btn">下一题</button>
          </div>
        </div>
      </div>

      <!-- 视频列表 -->
      <div class="scroll-container"
        style="flex: 0.3; padding: 1.875rem; background: rgba(0, 0, 0, 0.05); overflow-y: auto; max-height: 100vh;">
        <div class="kemu" style="display: flex; flex-wrap: wrap; margin: 0 auto; max-width: 100%;">
          <div class="kemu-item" v-for="(item, index) in videoList" :key="index" @click="switchKMTab(index)"
            :class="{ 'active': videoIndex == index }"
            style="padding: 8px 12px; margin: 5px; border-radius: 5px; cursor: pointer; transition: all 0.3s;">
            <span class="sequence-number">{{ (index + 1)<10 ? '0'+(index + 1):index + 1 }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        page: 1,
        navRight: false,
        title: '',
        cate_id: '',
        type: '',
        subject: '',
        car_type: '',
        isControls: true,
        timeLong: '',

        videoContext: '',
        video: '',
        vip: 0,
        videoSrc: '',
        videoList: [],
        videoIndex: 0,

        playOrStop: false,
        options: this.$store.state.pageParams,
      }
    },
    mounted() {
      this.videoContext = document.getElementById('myVideo');
      // 全局禁用右键
      document.addEventListener('contextmenu', e => e.preventDefault());
    },
    destroyed() {
      // 组件销毁时移除事件监听，避免影响其他页面
      document.removeEventListener('contextmenu', e => e.preventDefault());
    },
    async created() {
      if (this.options.id) {
        this.cate_id = this.options.id
      }
      await this.jiazai()
    },

    methods: {
      toHome() {
        window.history.back();
      },
      playVideo() {
        if (!this.videoSrc) {
          this.$alert('暂无可播放视频', '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          })
          return
        }
        this.videoContext.play();
        this.playOrStop = true;
      },
      pauseVideo() {
        this.videoContext.pause();
        this.playOrStop = false;
      },
      videoError(e) {
        console.log('视频播放错误:', e);
      },
      videoPlay() {
        console.log('视频开始播放');
        this.playOrStop = true;
      },
      videoPause() {
        console.log('视频暂停');
        this.playOrStop = false;
      },
      videoEnded() {
        console.log('视频播放结束');
        this.playOrStop = false;
      },
      jiazai() {
        console.log('jiazai');
        let that = this
        let src = '/User/questionVideo'
        let params = {
          test_paper_id: this.cate_id,
          limit: 10000,
          page: 1,
        }
        if (this.options.txt == '分类练习') {
          src = '/index/orderQuestionVideo'
          params = {
            cate_id: this.options.id,
            limit: 10000,
            page: 1,
          }
        }
        return new Promise((resolve, reject) => {
          this.axios
            .post(src, params)
            .then(res => {
              that.videoList = res
              if (this.options.txt == '分类练习') {
                that.videoList = res.data
              }

              that.videoSrc = that.videoList[that.videoIndex]['video']
              resolve(res)
            })
            .catch(error => {
              reject(error)
            })
        })
      },
      upVideo() {
        if (this.videoIndex === 0) {
          console.log('已经是第一个视频');
          return false;
        }
        this.videoIndex--;
        this.videoSrc = this.videoList[this.videoIndex]['video'];
        this.$nextTick(() => {
          this.videoContext.play();
        });
      },
      nextVideo() {
        if (this.videoIndex >= this.videoList.length - 1) {
          console.log('已经是最后一个视频');
          return false;
        }
        this.videoIndex++;
        this.videoSrc = this.videoList[this.videoIndex]['video'];
        this.$nextTick(() => {
          this.videoContext.play();
        });
      },
      switchKMTab(index) {
        this.videoIndex = index;
        this.videoSrc = this.videoList[this.videoIndex]['video'];
        this.$nextTick(() => {
          this.videoContext.play();
        });
      }
    },
  }
</script>

<style scoped>
  .control-btn {
    padding: 8px 16px;
    margin: 0 5px;
    border: none;
    background-color: #4285f4;
    color: white;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
  }

  .control-btn:hover {
    background-color: #3367d6;
  }

  .active {
    background-color: #4285f4;
    color: white;
  }

  .kemu {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20rpx;
  }

  .kemu-item {
    padding: 10rpx;
    border: 1px solid #ccc;
    border-radius: 5rpx;
    cursor: pointer;
    margin: 10rpx;
    text-align: center;
    width: 80rpx;
    height: 60rpx;
  }

  .kemu-default-color {
    color: blue;
  }

  /* 视频播放时的样式 */
  .video-playing::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url('/static/img/banner.png');
    background-size: cover;
    background-position: center;
    z-index: 1;
    opacity: 1;
    /* 添加过渡效果 */
    transition: opacity 0.5s ease;
  }

  .video-playing.playing::before {
    opacity: 0;
  }

  .scroll-container::-webkit-scrollbar {
    width: 6px;
  }

  .scroll-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  .scroll-container::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 10px;
  }

  .scroll-container::-webkit-scrollbar-thumb:hover {
    background: #aaa;
  }

  /* 视频列表项样式 */
  .kemu-item {
    padding: 8px 12px;
    margin: 5px;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s;
  }
  /* 序号样式 - 确保个位数和两位数宽度一致 */
  .sequence-number {
    display: inline-block;
    width: 30px; /* 固定序号宽度 */
    text-align: center; /* 文字居中 */
  }
  .kemu-item.active {
    background-color: #42b983;
    color: white;
  }

  .kemu-item:hover:not(.active) {
    background-color: #f0f0f0;
  }

  /* 控制按钮样式 */
  .control-btn {
    margin: 0 8px;
    padding: 6px 16px;
    border: none;
    border-radius: 4px;
    background-color: #42b983;
    color: white;
    cursor: pointer;
    transition: background-color 0.3s;
  }

  .control-btn:hover {
    background-color: #359e6d;
  }
</style>



// WEBPACK FOOTER //
// src/pages/case/video.vue